export default "__VITE_ASSET__Wwy4CeiN__"